import {Stack, Typography} from "@mui/material";
import React from "react";
import {useTheme} from "@mui/material/styles";
import {Construction} from "@mui/icons-material";

const Error = ({displayCode, displayStatus}) => {
  const theme = useTheme()
  return (
    <Stack
      justifyContent={'center'}
      alignItems={'center'}
      height="87vh"
      textAlign={'center'}
    >
      <Construction color='error' sx={{fontSize: '120px'}}/>
      <Typography color='error' fontSize='xx-large'>
        {displayCode}
      </Typography>
      <Typography color='error' fontSize='large'>
        {displayStatus}
      </Typography>
    </Stack>
  );
}

export default Error;